import { AppImage } from "@/src/components/NextImage";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Home/HomeTopQuestion";
import { cn } from "utils";
import { rootStore } from "@/src/store";
import { useSnapshot } from "valtio";

const I18n = I18nUtil.createScoped(Translations);

export const HomeTopQuestion = ({ isStickty }: { isStickty: boolean }) => {
  const { type } = useSnapshot(rootStore.home);

  return (
    <div
      className={cn("transition-all duration-300 md:px-0 px-4", {
        "sticky top-21 bg-background_solid_secondary bg-background_solid_secondary px-4 pt-6 pb-3 z-11":
          isStickty,
      })}
    >
      <div className="flex gap-0.5 px-0">
        <AppImage
          src="/assets/images/edgen.webp"
          alt="logo"
          width={24}
          height={24}
        />
        <h1
          aria-label="Home Top Question h1"
          data-openreplay-label="Home Top Question h1 Semantic"
          id="sem-home-top-question-h1"
          className="text-content_primary headline_regular_s"
        >
          {I18n.t("Ask Edgen AI")}
          <span className="text-content_tertiary equity-text-linear ml-1">
            {type === "crypto" ? "Crypto" : "Stocks"}
          </span>
        </h1>
      </div>
    </div>
  );
};
